import type { TypographyPreset } from '@/types/announcement';

/** Per-typography backdrop visibility presets ensuring safe contrast */
export interface BackdropPreset {
  /** Tailwind opacity class for the backdrop image */
  imageOpacity: string;
  /** Tailwind blur class for the backdrop image */
  imageBlur: string;
  /** Overlay gradient classes when auto-contrast is ON */
  overlayOn: string;
  /** Overlay gradient classes when auto-contrast is OFF */
  overlayOff: string;
}

const PRESETS: Record<TypographyPreset, BackdropPreset> = {
  // Serif fonts are thinner strokes → need stronger contrast (12% opacity)
  classic: {
    imageOpacity: 'opacity-[0.12]',
    imageBlur: 'blur-[3px]',
    overlayOn: 'from-background/50 via-background/55 to-background/75',
    overlayOff: 'from-background/15 via-background/20 to-background/35',
  },
  // Sans-serif is bolder → can show more image (18% opacity)
  modern: {
    imageOpacity: 'opacity-[0.18]',
    imageBlur: 'blur-[2px]',
    overlayOn: 'from-background/40 via-background/45 to-background/65',
    overlayOff: 'from-background/10 via-background/15 to-background/30',
  },
  // Cursive/italic is the hardest to read → strongest contrast (12% opacity)
  handwritten: {
    imageOpacity: 'opacity-[0.12]',
    imageBlur: 'blur-[4px]',
    overlayOn: 'from-background/55 via-background/60 to-background/80',
    overlayOff: 'from-background/20 via-background/25 to-background/40',
  },
};

export function getBackdropPreset(typography: TypographyPreset): BackdropPreset {
  return PRESETS[typography] ?? PRESETS.classic;
}
